import { render, staticRenderFns } from "./LoanIssues.vue?vue&type=template&id=c8665456&scoped=true"
import script from "./LoanIssues.vue?vue&type=script&lang=js"
export * from "./LoanIssues.vue?vue&type=script&lang=js"
import style0 from "./LoanIssues.vue?vue&type=style&index=0&id=c8665456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0_supports-_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8665456",
  null
  
)

export default component.exports